import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';


import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';


@Component({
  selector: 'app-side-bar-mentor-fcc',
  templateUrl: './side-bar-mentor-fcc.component.html',
  styleUrls: ['./side-bar-mentor-fcc.component.css'],
    animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarMentorFccComponent implements OnInit{

    constructor(private router: Router) {}
    user: any | null;
    profil: any;
    logged: any;
    role!: any;
    cohorte!: string;
    nomrole!: string;
    eleve: boolean = false;

    urlProgramme: string = '';
    hidden: boolean = false;
    isAdmin: boolean = false;
    isMentor: boolean = false;
    isAdminFcc: boolean = false;
   
    sections = [
      { id: 1, isCollapsed: true },
      { id: 2, isCollapsed: true },
      { id: 3, isCollapsed: true },
      { id: 4, isCollapsed: true },
    ];
  
    ngOnInit() {
      this.user = sessionStorage.getItem('user');
      this.logged = sessionStorage.getItem('logged');
      this.profil = JSON.parse(this.user).profile.id;
  
      this.role = JSON.parse(this.user)?.roles;
      // console.log('roles : ', this.role);
      this.cohorte = JSON.parse(this.user).beneficiaryCohortes[0]?.cohorte.cohorteName;
          console.log('user side bar admin :',this.user)
  
      console.log(this.cohorte);
      if (this.role.length > 0) {
        this.role.forEach((element: { id: number; roleName: any }) => {
          this.nomrole = element.roleName;
          sessionStorage.setItem('nomrole', this.nomrole);
          switch (element.roleName) {
            case 'admin': {
              this.isAdmin = true;
              break;
            }
            case 'mentor': {
              this.isMentor = true;
              break;
            }
            case 'admin-fcc': {
              this.isAdminFcc = true;
              break;
            }
          }
        });
        // console.log(
        //   "le profil de l'apprenant xxxxxx : ",
        //   this.profil
        // );
      }
  
      // console.log('user role: ', this.user);
    }

    reloadComponent(self: boolean, urlToNavigateTo?: string) {
      //skipLocationChange:true means dont update the url to / when navigating
      const url = self ? this.router.url : urlToNavigateTo;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`/${url}`]).then(() => {
          // console.log(`After navigation I am on:${this.router.url}`);
        });
      });
    }
    sessionChange(cohorte: string) {
      sessionStorage.setItem('cohorte', cohorte);
      this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
      setTimeout(() => {
        this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
      }, 500);
    }
    openUrl(url: string) {
      window.open(url, '_blank');
    }
  
    toggleCollapse(id: number): void {
      const section = this.sections.find((sec) => sec.id === id);
      if (section) {
        section.isCollapsed = !section.isCollapsed;
      }
    }
}
